import { useContext } from "react";
import { IconButton } from "@mui/material";
import { SettingsOutlined } from '@mui/icons-material';
import { useLocation, useNavigate } from "react-router-dom";
import UserContext from "common/Context/UserContext";
import { isPlatformAdminProfile } from "common/Utilities/Role.utils";
import { resetPlatformAdminCustomerSelection } from "common/Utilities/CustomerSelection.utils";
import { isHomeLandingPath } from "common/Components/Layout/SideNav.utils";
import { railActionButtonSx } from "../TopHeader.style";

const PlatformHomeButton = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { userProfile, setHeaderSelectedCustomer } = useContext(UserContext);
  const profile = userProfile?.profile;
  const showHomeButton =
    isPlatformAdminProfile(profile) && !isHomeLandingPath(pathname);

  if (!showHomeButton) {
    return null;
  }

  const handleHomeClick = () => {
    resetPlatformAdminCustomerSelection();
    setHeaderSelectedCustomer?.(null);
    if (isPlatformAdminProfile(profile)) {
      window.location.assign("/");
      return;
    }
    navigate("/");
  };

  return (
    <IconButton
      onClick={handleHomeClick}
      aria-label="Go to home"
      title="Go to home"
      sx={railActionButtonSx}
    >
      <SettingsOutlined alt="Gear Icon" />
    </IconButton>
  );
};

export default PlatformHomeButton;
